"use client";
'use strict';

var React = require('react');

/**
 * React hook that provides an enhanced keydown handler,
 * that's used for key navigation within menus, select dropdowns.
 */
function useKeyPress(props, deps = []) {
    const { keyMap, enabled } = props;
    // Add event listeners
    React.useEffect(() => {
        // If pressed key is our target key then run callback
        function handler(event) {
            const fn = keyMap[event.key];
            if (fn && typeof fn === 'function') {
                fn(event);
            }
        }
        if (enabled) {
            window.addEventListener('keydown', handler);
        }
        // Remove event listeners on cleanup
        return () => {
            window.removeEventListener('keydown', handler);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enabled, ...deps]);
}

exports.useKeyPress = useKeyPress;
//# sourceMappingURL=useKeyPress.js.map
